import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import FormSectionNew from "components/sales/formSection/formSectionNew";
import localization from "assets/localization/localization";
import DivLayout from 'components/sales/divLayout/divLayout';
import VendorForm from './vendorForm/vendorForm';
import mrfDetailsReducer from 'services/redux/installation/materialRequisition/reducer';

const VendorDetails = ({
    details,
    handleValue,
    siteId,
    size,
    documentUploadUrl,
    documentUrlData,
    vendorId,
    prSubType
}) => {
    const [quantityObj, setQuantityObj] = useState([]);
    const [remark, setRemark] = useState("");
    const [scope, setScope] = useState("Park+");
    const Size = details?.service?.length || 0;

    useEffect(() => {
        handleValue({
            site_id: siteId,
            data: quantityObj,
            size: Size,
            vendor_id: vendorId,
            pr_sub_type: prSubType,
            remark: remark,
            scope: prSubType == 2 ? scope : null,
        });
    }, [siteId, quantityObj, Size, vendorId, prSubType, remark, scope]);
    
    const handleForm = (val) => {
        // quantityObj.push(val);
        // setQuantityObj([...quantityObj])
        if (val === null) {
            return false;
        }
       
        if (val !== undefined && val !== null) {
            if (quantityObj && quantityObj.length === 0) {
                quantityObj.push(val);
                setQuantityObj([...quantityObj]);
            } else {
                const isThere = quantityObj.findIndex((obj) => obj.service_boq_id === val.service_boq_id);
                if (isThere === -1) {
                    quantityObj.push(val);
                    setQuantityObj([...quantityObj]);
                } else {
                    quantityObj.splice(isThere, 1);
                    quantityObj.push(val);
                    setQuantityObj([...quantityObj]);
                }
            }
        }
    }
    return (
        <FormSectionNew title={localization.vendorDetails}>
            <div className="details-listing">
                <DivLayout
                    heading={localization.vendorCode}
                    data={details?.vendor_code ? details.vendor_code : localization.na}
                />
                <DivLayout
                    heading={localization.vendorName}
                    data={details?.vendor_name ? details.vendor_name : localization.na}

                />
                <DivLayout
                    heading={localization.activeSites}
                    data={details?.active_sites ? details.active_sites : localization.na}
                />
            </div>

            <div className="row px-3 mt-3">
                <div className="col-md-4">
                    <ConstantInput
                        label="Remark"
                        type="text"
                        maxLength={200}
                        handleChange={(value) => setRemark(value)}
                        value={remark}
                        isStarRequired={false}
                    />
                </div>

                {prSubType == 2 && (
                    <div className="col-md-4">
                        <DropDownInput
                            data={[
                                { id: "Park+", name: "Park+" },
                                { id: "Client", name: "Client" },
                            ]}
                            label="Scope"
                            required
                            getIdValue={(val) => {
                                setScope(val.id);
                                handleForm(null); 
                            }}
                            isStarRequired={true}
                            getValueById={scope}
                        />
                    </div>
                )}
            </div>
               
                {details && details.service && Object.keys(details.service).length !== 0 ? details.service.map((item, index) => {
                    return (
                <>
                {details.serviceCount[item.service_id] !== undefined  ? (  
                    <> 
                <VendorForm
                    key={index}
                    details={item}
                    index={index}
                    handleVal={handleForm} 
                    size={Size}
                    documentUploadUrl={documentUploadUrl}
                    documentUrlData={documentUrlData}
                    inputVal={details.serviceCount[item.service_id]}
                />
                </>
                ):
                <VendorForm
                    key={index}
                    details={item}
                    index={index}
                    handleVal={handleForm} 
                    size={Size}
                    documentUploadUrl={documentUploadUrl}
                    documentUrlData={documentUrlData}
                    inputVal={0}
                /> 
                }
                </>
                
                    )
                   
                })
                    : null
                }
        </FormSectionNew>
    )
}

VendorDetails.propTypes = {

}

export default VendorDetails
